<template>
    <div class="page-container">
        <div class="page-top">
            <div class="card-block">
                <div class="card-top">
                    <div class="total-block">
                        <div class="total-num">{{pageData.inventory}}</div>
                        <div class="total-text">可提货总库存(瓶)</div>
                    </div>
                    <div class="link-detail" @click="jumpPage('stock-detail')">库存明细</div>
                </div>
                <div class="card-bottom">
                    <div class="bottom-item">
                        <div class="item-num">{{pageData.takeTotal}}</div>
                        <div class="item-text">总提货(瓶)</div>
                    </div>
                    <div class="bottom-item">
                        <div class="item-num">{{pageData.inTotal}}</div>
                        <div class="item-text">总入库商品(瓶)</div>
                    </div>
                    <div class="bottom-item">
                        <div class="item-num">{{pageData.exchangeTotal}}</div>
                        <div class="item-text">总兑换推荐奖励(瓶)</div>
                    </div>
                    <div class="bottom-item">
                        <div class="item-num">{{pageData.saleTotal}}</div>
                        <div class="item-text">总待释放销售奖励(瓶)</div>
                    </div>
                </div>
            </div>
            <div class="menu-list">
                <div class="menu-item" @click="jumpPage('pickup-apply')">
                    <img src="../../assets/icon-jh.png" alt="">
                    <div class="item-text">进货</div>
                </div>
                <div class="menu-item" @click="jumpPage('pickup-goods')">
                    <img src="../../assets/icon-th.png" alt="">
                    <div class="item-text">提货</div>
                </div>
                <div class="menu-item">
                    <router-link to="/stock/inout-order">
                        <img src="../../assets/icon-jt-record.png" alt="">
                        <div class="item-text">进/提货记录</div>
                    </router-link>
                </div>
            </div>
        </div>
        <!-- 商品分类库存 -->
        <div class="page-botom">
            <div class="bottom-title">商品分类库存 <span>(单位：瓶)</span></div>
            <div class="item-block" v-for="(item,index) in inventoryList" :key="index">
                <div class="item-top">
                    <img :src="item.picUrl" class="goods-pic" />
                    <div class="goods-info">
                        <div class="goods-name">
                            <div class="goods-name-text">{{`${item.name} ${item.degree}度 ${item.capacity}`}}</div>
                        </div>
                        <div class="goods-skus">单瓶</div>
                        <div class="now-stock">当前可售库存{{item.inventory}}瓶</div>
                    </div>
                </div>
                <div class="item-bottom">
                    <div class="item-counts-item">
                        <div class="item-number">{{item.inTotal}}</div>
                        <div class="item-text">累计进货</div>
                    </div>
                    <div class="item-counts-item">
                        <div class="item-number">{{item.sendTotal}}</div>
                        <div class="item-text">累计赠送</div>
                    </div>
                    <div class="item-counts-item">
                        <div class="item-number">{{item.takeTotal}}</div>
                        <div class="item-text">累计提货</div>
                    </div>
                    <div class="item-counts-item">
                        <div class="item-number">{{item.saleRelease}}</div>
                        <div class="item-text">销售待奖励</div>
                    </div>
                    <div class="item-counts-item">
                        <div class="item-number">{{item.saleTotal}}</div>
                        <div class="item-text">销售已奖励</div>
                    </div>
                    <div class="item-counts-item">
                        <div class="item-number">{{item.exchangeTotal}}</div>
                        <div class="item-text">兑换推荐奖</div>
                    </div>
                </div>
                <!-- <div class="aside-bottom">提货在途数量：{{item.stayOut}}(瓶)</div> -->
            </div>
        </div>
    </div>
</template>

<script>
import { Icon,Toast } from 'vant';

import $http from '@/lib/request'
import config from '@/config'
import { getLocalUserInfo } from '@/lib/util'

export default {
    data(){
        return {
            loading:false,
            showPop:false,
            pageData:{},//页面数据
            inventoryList:[],//商品分类库存列表
            userInfo:{},
        }
    },
    components:{
        [Icon.name]:Icon,
        [Toast.name]:Toast
    },
    activated(){
        let uInfo=getLocalUserInfo();
        if(uInfo){
            this.userInfo=uInfo;
        }

        $http({
            method:'post',
            url:config.api.stock
        }).then(res=>{
            if(res.errno == 0){
                this.pageData=res.data;
                this.inventoryList=res.data.inventoryList;
            }else{
                Toast(res.errmsg);
            }
        })
    },
    methods:{
        jumpPage(name){
            // if(name == 'pickup-apply' && this.userInfo.jypwd != 1){
            //     Toast('请先设置交易密码');
            //     return;
            // }
            if(name == 'pickup-goods' && this.pageData.inventory <= 0){
                Toast('请先去进货,再来提货哦');
                return;
            }
            this.$router.push({
                name:name
            });
        },
    }
}
</script>

<style lang="scss" scoped>
@mixin flex-between{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.page-container{
    width:100vw;
    height:calc(100vh - 46px);
    background:#f5f5f5;
    .page-top{
        padding:10px;
        background:#fff;
        margin-bottom: 10px;
        .card-block{
            background: linear-gradient(310deg, #3CA7FE 0%, #3088F5 100%);
            border-radius: 14px;
            padding:20px 25px;
            color:#fff;
            .card-top{
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                padding-bottom: 20px;
                border-bottom: 1px solid rgba(245,245,245,0.1);
                .total-block{
                    .total-num{
                        font-size: 30px;
                        font-family: DINAlternate-Bold, DINAlternate;
                        font-weight: bold;
                        line-height: 35px;
                        margin-bottom: 5px;
                    }
                    .total-text{
                        line-height: 18px;
                        font-size: 12px;
                        color:rgba(255,255,255,0.7);
                    }
                }
                .link-detail{
                    font-size: 14px;
                    line-height: 20px;
                    color:rgba(255,255,255,0.8);
                }
            }
            .card-bottom{
                margin-top: 20px;
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                flex-wrap: wrap;
                .bottom-item{
                    width:50%;
                    margin-bottom: 16px;
                    .item-num{
                        font-size: 18px;
                        font-weight: bold;
                        line-height: 22px;
                        margin-bottom: 5px;
                        font-family: DINAlternate-Bold, DINAlternate;
                    }
                    .item-text{
                        line-height: 18px;
                        font-size: 12px;
                        color:rgba(255,255,255,0.7);
                    }
                    &:nth-child(3),&:nth-child(4){
                        margin-bottom: 0;
                    }
                }
            }
        }
        .menu-list{
            padding:20px 0;
            display: flex;
            justify-content: center;
            align-items: flex-start;
            .menu-item{
                width:80px;
                text-align: center;
                &:nth-child(2){
                    margin:0 40px;
                }
                & img{
                    width:40px;
                    height:40px;
                    margin-bottom: 5px;
                }
                .item-text{
                    font-size: 13px;
                    color:#333;
                }
            }
        }
    }
    .page-botom{
        background:#fff;
        width:100%;
        padding:15px;
        box-sizing: border-box;
        .bottom-title{
            font-size: 16px;
            line-height: 22px;
            color:#333;
            margin-bottom: 10px;
            &>span{
                color:#999;
                font-size: 12px;
            }
        }
        .item-block{
            background: rgba(245,245,245,0.5);
            border-radius: 4px;
            margin-bottom: 10px;
            padding:15px;
            padding-bottom: 0;
            box-sizing: border-box;
            .item-top{
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                .goods-pic{
                    width:72px;
                    height:72px;
                    margin-right: 10px;
                    border-radius: 4px;
                }
                .goods-info{
                    display: flex;
                    justify-content: space-between;
                    flex-direction: column;
                    height:72px;
                    .goods-name{
                        display: flex;
                        justify-content: space-between;
                        align-items: flex-start;
                        margin-bottom: 10px;
                        .goods-name-text{
                            color:#000;
                            font-size: 14px;
                        }
                    }
                    .goods-skus{
                        color:#999;
                        font-size: 12px;
                    }
                    .now-stock{
                        font-size: 12px;
                        color: #e43d3d;
                    }
                }
            }
            .item-bottom{
                display: flex;
                justify-content: space-around;
                align-items: flex-start;
                flex-wrap: wrap;
                padding-bottom: 15px;
                .item-counts-item{
                    width: 33%;
                    text-align: center;
                    margin-top:20px;
                    .item-number{
                        font-family: DINAlternate-Bold, DINAlternate;
                        font-weight: bold;
                        color:#333;
                        font-size: 18px;
                        line-height: 22px;
                    }
                    .item-text{
                        font-family: PingFangSC-Regular, PingFang SC;
                        color:#999;
                        opacity: 0.7;
                        font-size: 14px;
                        line-height: 18px;
                    }
                }
            }
            .aside-bottom{
                border-top:1px solid rgba(230,230,230,0.5);
                height:44px;
                line-height: 44px;
                font-size: 13px;
                color:#999;
                margin-top: 15px;
            }
        }
    }
}
</style>